import { Dialog } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  isLoading?: boolean;
}

export const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  isLoading = false,
}: ConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[1300]">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
        <Dialog.Panel className="bg-white rounded-lg p-6 max-w-md w-full max-h-[90vh] flex flex-col overflow-hidden my-auto">
          <Dialog.Title className="text-lg font-medium flex-shrink-0 mb-4">{title}</Dialog.Title>
          <div className="flex-1 min-h-0 overflow-y-auto">
            <p className="mb-4">{message}</p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300"
                disabled={isLoading}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={onConfirm}
                className="px-4 py-2 text-sm text-white rounded flex items-center bg-red-600 hover:bg-red-700"
                disabled={isLoading}
              >
                {isLoading && (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                )}
                {t('common.confirm')}
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
